<template>
  <div class="user-info">
    <img class="avatar" src="~@/assets/logo.png" />
    <div class="user-details">
      <div>
        {{ user.username }}
      </div>
      <div>
        {{ user.email }}
      </div>
    </div>
    <div class="theme">
      <el-popover
        v-model="popoverVisible"
        placement="bottom"
        width="200"
        trigger="click"
      >
        <el-button type="text" @click="handleSettings">Settings</el-button>
        <el-button type="text" @click="handleAbout">About</el-button>
        <el-button type="text" @click="handleLogout">Log Out</el-button>
        <i class="el-icon-s-tools" slot="reference" style="cursor: pointer"></i>
      </el-popover>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { MessageBox } from "element-ui";
import { EventBus } from "@/event-bus.js";

export default {
  name: "UserInfo",
  data() {
    return {
      popoverVisible: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
  methods: {
    handleSettings() {
      this.popoverVisible = false;
      this.$router.push({
        name: "settings",
      });
    },
    async handleAbout() {
      this.popoverVisible = false;
      /**
       * Displays an alert dialog showing the current build number of the application.
       * The dialog includes a title "About" and an "OK" confirmation button.
       *
       * macOS: Press Cmd+Shift+R to force refresh the browser.
       * Windows: Press Ctrl+Shift+R to force refresh the browser.
       */
      await MessageBox.alert(
        "Build Number: " +
          process.env.VUE_APP_BUILD_NUMBER +
          "<p>Force refresh the browser:</p>" +
          "<p>macOS: Press <kbd>Cmd</kbd>+<kbd>Shift</kbd>+<kbd>R</kbd>.</p><p>Windows: Press <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>R</kbd>.</p><p>linux: Press <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>R</kbd>.</p>",
        {
          title: "About",
          confirmButtonText: "OK",
          dangerouslyUseHTMLString: true,
        }
      );
    },
    async handleLogout() {
      this.popoverVisible = false;
      await MessageBox.confirm("Are you sure you want to log out?", {
        confirmButtonText: "Log Out",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      EventBus.$emit("logout");
    },
  },
};
</script>

<style scoped>
.user-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px;
  color: white;
  gap: 10px;
}

.user-info .avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #fff;
}

.user-info .user-details {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.user-info .theme {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 20px;
  padding: 10px;
}
</style>
